import { useEffect } from 'react';
import { useField } from 'formik';

const useDefaultFormikValue = <T>(name: string, defaultValue: T | undefined): void => {
  const [field, , helpers] = useField<T | undefined>(name);
  useEffect(() => {
    if (defaultValue !== undefined && field.value === undefined) {
      helpers.setValue(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useDefaultFormikValue;
